import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  canonical,
  image = "https://babatourumroh.com/favicon.png",
}) {
  return (
    <Helmet>
      <title>{title}</title>

      {canonical && (
        <link rel="canonical" href={canonical} />
      )}

      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
